import Vue from "vue";

Vue.directive("open-mobile-filter",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                if (document.querySelector(".mobile-filter"))
                {
                    document.querySelector(".mobile-filter").classList.add("open");
                    document.querySelector("body").classList.add("menu-is-visible");
                }
            };
        }
    });
